import { useMutation } from "@tanstack/react-query";

import { UserLoginT } from "@/features/auth/components/Login/models";
import { TokensT, saveLegacyTokens, saveNamekToken } from "@/features/auth/store/tokens.store";

import { postOrionLogin } from "./orionv2/postOrionLogin";
import { OrionV2AuthenticateResponseT } from "./orionv2";

const postLoginUser = async (data: UserLoginT): Promise<OrionV2AuthenticateResponseT> => {
  const orionData = await postOrionLogin(data);

  const legacyTokens: TokensT = {
    authToken: orionData.legacyToken,
    refreshToken: orionData.legacyRefreshToken,
  };
  saveLegacyTokens(legacyTokens);
  saveNamekToken(orionData.token);

  return orionData;
};

export const useLoginUser = () => {
  return useMutation({
    mutationFn: (data: UserLoginT) => postLoginUser(data),
  });
};
